import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";



const axisNameColor = '#334155';
const completedBarColor = '#00ff88';
const pendingBarColor = '#b6c2bd';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'



const GaugeChart = ({
    chartLabel = "",
    chartData = null,
    fieldsLabel = "",
    height = 320,
    valueField = "efficiency",
    statusField = "gaugeStatus",
    min = 0,
    max = 100,
    startAngle = 200,
    endAngle = -20,
    radius = "72%",
    center = ["50%", "72%"],
    progressColor = "#19B885",
    backgroundColor = "#E8EDF5",
    pointerColor = "#1E293B",
    pointerWidth = 5,
    pointerLength = "62%",
    gaugeWidth = 20,
    showValue = false,
    showStatus = false,
    tooltipFields = [],
    purpose = "",
    gaugeLabel,

}) => {

    // // Dummy Data (API na ho to)
    // const dummyData = {
    //     totalTasks: 4706,
    //     totalEstimateHours: 10672.62,
    //     totalActualHours: 11030.38,
    //     slippage: 3.35,
    //     efficiency: 96.76,
    //     gaugeStatus: "Excellent",
    // };

    const data = chartData ?? [];

    const value = Number(data?.[valueField] ?? 0);

    const option = {
        tooltip: {
            trigger: "item",
            z: 9999,
            zlevel: 9999,
            appendTo: () => document.body,
            formatter: () => {
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }
                tooltipFields.forEach(field => {

                    html += `<b>${field.label}</b> : ${data?.[field.key] ?? "-"}<br/>`;

                });

                return html;
            },
        },

        legend: {
            show: true,
            top: 5,
            left: "center",
            icon: "roundRect",
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
            data: [
                {
                    name: gaugeLabel,
                    itemStyle: {
                        color: progressColor,
                    },
                },
            ],
        },
        series: [
            {
                name: gaugeLabel,
                type: "gauge",
                startAngle,
                endAngle,
                min,
                max,
                radius,
                center,
                progress: {
                    show: true,
                    width: gaugeWidth,
                    roundCap: false,
                    itemStyle: {
                        color: progressColor,
                    },
                },

                axisLine: {
                    lineStyle: {
                        width: gaugeWidth,
                        color: [
                            [1, backgroundColor]
                        ],
                    },
                },

                pointer: {
                    show: true,
                    width: pointerWidth,
                    length: pointerLength,
                    itemStyle: {
                        color: pointerColor,
                    },
                },

                anchor: {
                    show: true,
                    size: 16,
                    itemStyle: {
                        color: pointerColor,
                    },
                },

                axisTick: {
                    show: false,
                },

                splitLine: {
                    show: false,
                },

                axisLabel: {
                    show: false,
                },

                detail: {
                    show: showValue,
                    offsetCenter: [0, "45%"],
                    formatter: "{value}%",
                    fontSize: 24,
                    fontWeight: "bold",
                    color: "#111827",
                },

                data: [
                    {
                        value,
                    },

                ],

            },

        ],

    };

    return (

        <ChartCard
            title={chartLabel}
            fields={fieldsLabel}
            height={height}
        >

            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />

        </ChartCard>

    );
};

export default GaugeChart;